import React from 'react';
import Hero from './Hero/Hero';
import AboutApp from './AboutApp/AboutApp'
import AppTasks from './AppTasks/AppTasks'
import AppDownload from './AppDownload/AppDownload'
import Feauters from './Feauters/Feauters'
import Faqs from './Faqs/Faqs';
import Newsletter from './Newsletter/Newsletter'
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';

const Members = () => {
    return (
        <Page>
            <SeoHelmet title="Members - Elite Partyz App" keywords="The only app you need for your next event party function A free and exciting game changing app for any event, party or function..." canonicalLink="/members" />
            <div className="members-page">
                <Hero />
                <AboutApp />
                <AppTasks />
                <AppDownload />
                <Feauters />
                <Faqs />
                <Newsletter />
            </div>
        </Page>
    )
}

export default Members
